"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = ({ colour = "currentColor" }) => {
    return (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.6667 9H28.3333C29.8061 9 31 10.1939 31 11.6667V28.3333C31 29.8061 29.8061 31 28.3333 31H11.6667C10.1939 31 9 29.8061 9 28.3333V11.6667C9 10.1939 10.1939 9 11.6667 9ZM13 14C12.4477 14 12 14.4477 12 15V27C12 27.5523 12.4477 28 13 28H27C27.5523 28 28 27.5523 28 27V15C28 14.4477 27.5523 14 27 14H13Z", fill: colour }));
};
//# sourceMappingURL=Window.js.map